import { Action, State, StateContext, Store } from "@ngxs/store";
import { ProcessingActions } from "./actions";

export class ProcessingStateModel {
  error: string;
  message: string;
  isProcessing: boolean;
  isEmailBatchSending: boolean;
}

const defaultState: ProcessingStateModel = {
  error: null,
  message: null,
  isProcessing: false,
  isEmailBatchSending: false,
};

@State<ProcessingStateModel>({
  name: 'processing',
  defaults: defaultState
})

export class ProcessingState {

  constructor() {}

  @Action(ProcessingActions.Reset)
  reset(ctx: StateContext<ProcessingStateModel>, action: ProcessingActions.Reset) {
    ctx.setState(defaultState);
  }

  @Action(ProcessingActions.SetEmailBatchSending)
  setEmailBatchSending(ctx: StateContext<ProcessingStateModel>, action: ProcessingActions.SetEmailBatchSending) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      isEmailBatchSending: action.isSending,
      message: null
    });
  }

  @Action(ProcessingActions.SetEmailBatchSendingMessage)
  SetEmailBatchSendingMessage(ctx: StateContext<ProcessingStateModel>, action: ProcessingActions.SetEmailBatchSendingMessage) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      isEmailBatchSending: action.isSending,
      message: action.msg
    });
  }

  @Action(ProcessingActions.SetProcessing)
  setProcessing(ctx: StateContext<ProcessingStateModel>, action: ProcessingActions.SetProcessing) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      isProcessing: action.isProcessing
    });
  }

  @Action(ProcessingActions.SetMessage)
  setMessage(ctx: StateContext<ProcessingStateModel>, action: ProcessingActions.SetMessage) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      message: action.message
    });
  }

  @Action(ProcessingActions.ClearMessage)
  clearMessage(ctx: StateContext<ProcessingStateModel>, action: ProcessingActions.ClearMessage) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      message: null
    });
  }

  @Action(ProcessingActions.SetError)
  setError(ctx: StateContext<ProcessingStateModel>, action: ProcessingActions.SetError) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      error: action.error
    });
  }

  @Action(ProcessingActions.ClearError)
  clearError(ctx: StateContext<ProcessingStateModel>, action: ProcessingActions.ClearError) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      error: null
    });
  }



}
